import { h } from 'preact';
import * as BaseComp from 'components/bolt/synopsis/synopsis.js';
import { accessNested, joinClasses } from 'utils/utils';
import Store from 'store/store';
// import { navigateInternally } from 'utils/bolt';
import { getDynamicData } from 'utils/bolt/dynamicData';

import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import * as webp from 'utils/bolt/webp';

import s from 'components/bolt/synopsis/synopsis.sss';

export default class Synopsis extends BaseComp.default {
	constructor(props) {
		super(props);
		this.state = {
			onesheetExpanded: false
		};
	}

	async componentDidMount() {
		super.componentDidMount?.();

		const { appData } = Store.get();
		if (appData?.options?.cmsManaged) {
			const activePage = Store.get().activePage;

			switch (activePage) {
				case 'aboutUs':
					await this.loadCustomData(await getDynamicData('about-us'));
					break;
			}
		}
	}

	toggleOnesheetFullScreen = () => {
		const isExpanded = this.state.onesheetExpanded;

		if (!isExpanded) {
			let imageUrl;

			if (this.props.id === 'filmSynopsis') {
				imageUrl = accessNested(this.props, 'pageData.onesheet', null);
			} else {
				imageUrl = accessNested(this.props, `appData.pages.${this.props.id}.data.onesheet`, null);
			}

			const imageName = imageUrl?.split('/').pop();
			Store.emit('SYNOPSIS_ENLARGE_IMAGE', imageName);

			this.setState({ onesheetExpanded: true });
			Store.emit('TOGGLE_ONESHEET', this.props.id);
		} else {
			this.setState({ onesheetExpanded: false });
			Store.emit('TOGGLE_ONESHEET', null);
		}
	};

	getFallbackFormat() {
		return accessNested(this.props, 'appData.pages.boltSynopsis.data.alternativeImageFormat', 'jpg');
	}
	renderExpandedOnesheet(onesheet, onesheetAltText) {
		const onesheetExpanded = this.state.onesheetExpanded;
		const store = Store.get();
		const sonyHeaderEnabled = accessNested(store, 'appData.options.sonyFeatures.sonyHeader', false);
		const externalBannerOpen = accessNested(store, 'externalCookieBanner.bannerOpen', false);
		const fallbackFormat = this.getFallbackFormat();

		let paddingTop = 0;

		if (sonyHeaderEnabled) {
			paddingTop += 34;
		}
		if (externalBannerOpen) {
			paddingTop += accessNested(store, 'externalCookieBanner.height', 0);
		}

		return (
			<div
				class={joinClasses(s.onesheetFullScreen, onesheetExpanded && s.visible)}
				onClick={this.toggleOnesheetFullScreen}
				style={{ paddingTop: paddingTop + 'px' }}
				key="onesheet-fullscreen"
			>
				<BurgerMenu type={onesheetExpanded ? 'close' : 'burger'} oneSheetOverlay extraClass={s.oneSheetOverlayCloseButton} />
				<webp.Picture src={onesheet} alt={onesheetAltText} fallbackFormat={fallbackFormat} onClick={this.stopPropagation} />
			</div>
		);
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) {
			return;
		}
		const { appData } = Store.get();
		if (!appData?.options?.cmsManaged || !dynamicData) return;

		this.dynamicData = {
			content: dynamicData.synopsis.content,
		};

		this.forceUpdate();
	}

	renderDetails(pageData, baseCopy) {
		const dynamicContent = this.dynamicData?.content;
		const updatedPageData = {
			...pageData,
			content: dynamicContent || pageData.content || this.content || baseCopy[pageData.content]
		};

		return super.renderDetails(updatedPageData, baseCopy);
	}
}